var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3044 20.087V29.1304C17.3044 31.8198 19.4845 34 22.1739 34C24.8633 34 27.0435 31.8198 27.0435 29.1304V28.4348M35.3913 18.6957H2C2 9.4749 9.4749 2 18.6957 2C27.9164 2 35.3913 9.4749 35.3913 18.6957Z",
    stroke: "#2337A9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5512 14C17.8943 11.2663 19.208 9.73367 21.5512 7M15.0128 7.53408L15.001 7.52019M22.1049 13.536L22.0931 13.5221",
    stroke: "#2337A9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.9d6211f5a1727a9feb9397d07fb369ae.svg";
export { ForwardRef as ReactComponent };